var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.65512 2.48926C2.94738 2.48926 1.5625 3.85991 1.5625 5.55095C1.5625 6.91604 2.10371 10.1559 7.43106 13.431C7.52649 13.489 7.63604 13.5197 7.74774 13.5197C7.85945 13.5197 7.969 13.489 8.06443 13.431C13.3918 10.1559 13.933 6.91604 13.933 5.55095C13.933 3.85991 12.5481 2.48926 10.8404 2.48926C9.13262 2.48926 7.74774 4.34483 7.74774 4.34483C7.74774 4.34483 6.36287 2.48926 4.65512 2.48926Z",
    stroke: "#506473",
    strokeWidth: 1.23705,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8446,
    height: 14.8446,
    fill: "white",
    transform: "translate(0.328125 0.633789)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/Love.6128e401dcf9a8c41d5feb24fc861130.svg";
export { ForwardRef as ReactComponent };